import { memo } from "react";
import Hero from "../components/Blog/Hero";
import BlogGrid from "../components/Blog/BlogGrid";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useImagePreloader from "../hooks/useImagePreloader";
import LoadingOverlay from "../components/LoadingOverlay";

import blogHeroImage from "/images/Blog/Hero.webp";
import blogPost1 from "/images/Blog/BlogPost1.webp";
import blogPost2 from "/images/Blog/BlogPost2.webp";
import blogPost3 from "/images/Blog/BlogPost3.webp";

const Blog = memo(function Blog() {
  useDocumentTitle("blog");

  const imagesToLoad = [blogHeroImage, blogPost1, blogPost2, blogPost3];

  const loading = useImagePreloader(imagesToLoad);

  const blogImages = {
    post1: blogPost1,
    post2: blogPost2,
    post3: blogPost3,
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <main>
        <Hero heroImage={blogHeroImage} />
        <BlogGrid blogImages={blogImages} />
      </main>
    </>
  );
});

export default Blog;
